<template>
  <div class="swiper-container" ref="swiperContainer" :style="{'width': width, 'height': height}">
    <div class="swiper-wrapper">
      <slot></slot>
    </div>
    <div :class="pagination" v-if="pagination" ref="pagination"></div>
    <div class="swiper-button-prev" v-if="navigation" ref="prevButton" @click="prev"></div>
    <div class="swiper-button-next" v-if="navigation" ref="nextButton" @click="next"></div>
  </div>
</template>
<script>
import Swiper from 'swiper'
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: 'auto'
    },
    autoplay: {
      type: Number,
      default: 5000
    },
    speed: { // 轮播速度
      type: Number,
      default: 300
    },
    autoplayDisableOnInteraction: { // 用户操作后是否停止轮播
      type: Boolean,
      default: false
    },
    mode: { // 轮播的方向
      type: String,
      default: 'horizontal'
    },
    loop: { // 是否循环
      type: Boolean,
      default: true
    },
    slidesPerView: { // 容器能够同时显示的slides数量
      type: Number,
      default: 1
    },
    calculateHeight: {
      type: Boolean,
      default: false
    },
    cssWidthAndHeight: {
      type: [Boolean, String],
      default: true
    },
    preventLinks: {
      type: Boolean,
      default: true
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: String,
      default: 'swiper-pagination'
    },
    isPagination: {
      type: Boolean,
      default: true
    },
    paginationClickable: {
      type: Boolean,
      default: true
    },
    navigation: {
      type: Boolean,
      default: true
    },
    // onSlideClick: {
    //   type: Function,
    //   default: function () {}
    // },
    onTouchStart: {
      type: Function,
      default: function () {}
    },
    onTouchEnd: {
      type: Function,
      default: function () {}
    }
  },
  beforeDestroy () {
    this.destroy()
  },
  methods: {
    init () {
      let options = {
        autoplay: this.autoplay,
        speed: this.speed,
        autoplayDisableOnInteraction: this.autoplayDisableOnInteraction,
        mode: this.mode,
        loop: this.loop,
        slidesPerView: this.slidesPerView,
        calculateHeight: this.calculateHeight,
        autoResize: this.autoResize,
        preventLinks: this.preventLinks,
        navigation: this.navigation,
        paginationClickable: this.paginationClickable,
        // onSlideClick: (swiper) => {
        //   this.onSlideClick(swiper.clickedSlide)
        // },
        onTouchStart: this.onTouchStart,
        onTouchEnd: this.onTouchEnd,
        onAutoplayStop: (swiper) => {
          if (this.autoplay) {
            // swiper.startAutoplay()
          }
        }
      }
      if (this.isPagination) {
        options.pagination = this.$refs.pagination
      } else {
        delete options.pagination
      }
      this.$nextTick(() => {
        this.swiper = new Swiper(this.$refs.swiperContainer, options)
      })
    },
    prev () {
      // this.swiper && this.swiper.swipePrev()
      this.swiper && this.swiper.slidePrev()
    },
    next () {
      // this.swiper && this.swiper.swipeNext()
      this.swiper && this.swiper.slideNext()
    },
    destroy () {
      this.swiper && this.swiper.destroy()
    }
  }
}
</script>
<style lang="stylus">
@import '../../stylus/swiper@3.4.2.styl'
.swiper-pagination
  position absolute
  z-index 20
  bottom 10px
  width 100%
  text-align center
.swiper-button-prev,
.swiper-button-next
  position absolute
  width 32px
  height 32px
  color #fff
  top 50%
  margin-top -16px
  font-size 32px
  background-image none
  cursor pointer
.swiper-button-prev
  left 10px
.swiper-button-next
  right 10px
</style>



// WEBPACK FOOTER //
// swiper.vue?53fb803c